(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection-restock"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-items"] && !Shopify.designMode) return;
  try {
    
  class RelatedProductsCarousel {
    constructor(container) {
      this.container = container;
      this.carousel = container.querySelector('[data-carousel="carousel"]');
      if (!this.carousel) return;

      this.prevBtn = container.querySelector('.carousel-nav--prev');
      this.nextBtn = container.querySelector('.carousel-nav--next');
      
      this.init();
    }

    init() {

      if (this.prevBtn) {
  this.prevBtn.addEventListener('click', (e) => { e.preventDefault(); e.stopPropagation(); this.scroll('prev'); });
}
if (this.nextBtn) {
  this.nextBtn.addEventListener('click', (e) => { e.preventDefault(); e.stopPropagation(); this.scroll('next'); });
}


   let startX = 0;
this.container.addEventListener('touchstart', (e) => { startX = e.touches[0].clientX; }, { passive: true });
this.container.addEventListener('touchend', (e) => {
  const diff = startX - e.changedTouches[0].clientX;
  if (Math.abs(diff) > 50) this.scroll(diff > 0 ? 'next' : 'prev');
});

    }

    scroll(direction) {
      const scrollAmount = this.carousel.offsetWidth;
      const scrollLeft = direction === 'prev' ? -scrollAmount : scrollAmount;
      this.carousel.scrollBy({ left: scrollLeft, behavior: 'smooth' });
    }
  }

  document.querySelectorAll('.resource-list-wrapper--carousel').forEach(wrapper => {
    new RelatedProductsCarousel(wrapper);
  });

  } catch(e) { console.error(e); }
})();
})();
